export default __webpack_public_path__ + "static/media/Anil.82143b79.png";